import { Button, Paper, Text } from "@mantine/core";
import { useState } from "react";
import { ProspectingEvent } from "./types.ts";
import { formatCgt, numberFormat } from "./utils.ts";
import style from "./AsteroidField.module.css";

interface EventLogProps {
  events: ProspectingEvent[];
  materialNames: Record<string, string>;
}

export default function EventLog({ events, materialNames }: EventLogProps) {
  const [visible, setVisible] = useState(false);

  return (
    <Paper p="sm" mt="sm" withBorder>
      <div className={style.summaryHead}>
        <Text fw={700}>Prospecting Log ({events.length})</Text>
        <Button size="compact-xs" variant="subtle" onClick={() => setVisible((v) => !v)}>
          {visible ? "Hide" : "Show"}
        </Button>
      </div>

      {visible ? (
        <table className={style.table}>
          <thead>
            <tr>
              <th>Date</th>
              <th>Location</th>
              <th>Trace</th>
              <th>Deposit</th>
            </tr>
          </thead>
          <tbody>
            {events
              .slice()
              .sort((a, b) => b.date - a.date)
              .map((event) => (
                <tr key={`${event.date}-${event.system.x}-${event.system.y}`}>
                  <td>{formatCgt(event.date)}</td>
                  <td>
                    ({event.system.x},{event.system.y})
                  </td>
                  <td>{event.trace > 0 ? `${event.trace} away` : event.trace === 0 ? "Found" : "None"}</td>
                  <td>
                    {event.deposit
                      ? `${numberFormat.format(event.deposit.size)} of ${materialNames[event.deposit.type] ?? event.deposit.type}`
                      : "None"}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      ) : null}
    </Paper>
  );
}
